<template>
    <div class="dark-blue hero">
    
      <v-container class="px-10 mt-lg-10 mt-xs-6 mt-sm-8 mt-md-8 pt-12 d-flex align-center justify-center fill-height" fluid>
        <v-row cols="12">
            <v-col cols="2"></v-col>
            <v-col cols="12" md="5" class="d-flex justify-center flex-column">
                <h1 class="section__header-title white--text text-h2 font-weight-bold">Yabbr Chat</h1>
                <h2 class="white--text text-h5 font-italic mb-5">One chat window. Every channel. Instant engagement.</h2>
                <h2 class="white--text text-subtitle-1">With Yabbr Chat, your team handles Email, SMS, MMS, and Voice messages—all in one streamlined conversation view.
                </h2>
            </v-col>
            <v-col cols="12" md="4">
                <v-row>
                <v-sheet class="mb-8 left-message bg-primary rounded-lg px-5 py-2 step-1" color="#d7dae1"></v-sheet>
            </v-row>
            <v-row justify="end">
                <v-sheet class="mb-8 right-message bg-primary rounded-lg px-5 py-2 white--text step-2" color="#1582d8"></v-sheet>
            </v-row>
            <v-row>
                <v-sheet class="mb-8 left-message bg-primary rounded-lg px-5 py-2 step-3" color="#d7dae1"></v-sheet>
            </v-row>
            <v-row justify="end">
                <v-sheet class="mb-8 right-message bg-primary rounded-lg px-5 py-2  white--text step-4" color="#1582d8"></v-sheet>
            </v-row>
            </v-col>
            
        </v-row>
        
      </v-container>
    </div>
  </template>
  
<script>
    export default {
    name: 'ChatHero',
    }
</script>

<style lang="scss">


.left-message, .right-message {
    width: 60%;
    position: relative;
    height: 70px;
}
.left-message::after, .right-message::after {
    content: '';
    position: absolute;
    
    border: 12px solid;
    
}

.left-message::after {
    left: -11px;
    top: 0;
    border-color: #d7dae1 transparent transparent transparent;
}

.right-message::after {
    right: -11px;
    top: 0;
    border-color: #1582d8 transparent transparent transparent;
}


.step-1 {
    animation: emphasise 4s ease-in-out infinite;
}

.step-2 {
    animation: emphasise 4s ease-in-out infinite;
    animation-delay: 1s;
}

.step-3 {
    animation: emphasise 4s ease-in-out infinite;
    animation-delay: 2s;
}

.step-4 {
    animation: emphasise 4s ease-in-out infinite;
    animation-delay: 3s;
}


@keyframes emphasise {
	0% {

        transform: scale(1.0);
	}
    12% {

        transform: scale(1.1);
	}
    25% {

        transform: scale(1.0);
    }
}



</style>
  